import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { unFormatCurrency } from '@/common/utils/unFormatters'
import { CreateSupplyAuthorizationValidationSchema } from '@/features/billingBills/schemas/createSupplyAuthorization.schema'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

interface UseCreateBillingSupplyAuthorizationProps {
  billId?: string
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: ErrorResponse) => void
}

export const useCreateBillingSupplyAuthorization = ({
  billId,
  onSuccess,
  onError,
}: UseCreateBillingSupplyAuthorizationProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createBillingSupplyAuthorization', billId],
    mutationFn: async ({ form }: { form: CreateSupplyAuthorizationValidationSchema }) => {
      const supply_authorization = {
        government_allocation_id: form.government_allocation_id,
        allocation_accounting_number: form.allocation_accounting_number,
        amount: unFormatCurrency(form.amount),
        file: form.file,
      }

      return await privateAxios.postForm(`/billing/supply_authorizations?bill_id=${billId}`, {
        supply_authorization,
      })
    },
    onSuccess,
    onError,
  })
}
